import { Box, styled } from '@mui/material'

export const AvatarContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '318px',
  width: '318px',
  borderRadius: '12px',
  overflow: 'hidden',
  flexShrink: 0,
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    height: '222px',
    width: '222px',
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
    height: '200px',
    width: '200px',
  },
}))
